module.exports = __webpack_public_path__ + "media/images/instagram-6671d916.svg";